import React from 'react'
import ReactDOM from 'react-dom/client'
import AutomationROICalculator from './AutomationROICalculator.tsx'
import './index.css'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AutomationROICalculator />
  </React.StrictMode>,
)
